<template>
	<div class="form-group">
		<label :for="id" v-if="label">
			{{ label }}
			<span
				class="required"
				v-if="
					Object.keys(validation).length > 0 &&
						(validation.hasOwnProperty('required') || !validation.requiredIf)
				"
				>*</span
			>
		</label>
		<div>
			<select
				:class="{
					'input-wrapper-error':
						Object.keys(validation).length > 0 &&
						(validation.hasOwnProperty('required') || !validation.requiredIf) &&
						this.validation.$invalid &&
						this.validation.$dirty
							? true
							: false,
					'input-wrapper-success':
						Object.keys(validation).length > 0 &&
						(validation.hasOwnProperty('required') || !validation.requiredIf) &&
						this.validation.$invalid
							? false
							: true,
					'custom-select': !this.validation.$dirty ? true : false,
					'form-control': true,
					'is-invalid':
						Object.keys(validation).length > 0 &&
						(validation.hasOwnProperty('required') || !validation.requiredIf) &&
						this.validation.$invalid
							? true
							: false,
				}"
				:id="id"
				:value="value"
				v-model="value"
				@input="$emit('update:value', $event.target.value)"
				:disabled="disabled != ''"
				:required="required"
				@change="change($event)"
			>
				<slot />
			</select>
		</div>
		<small class="form-text text-muted field-helper" v-if="helper">{{ helper }}</small>
		<validation :v="validation" />
	</div>
</template>

<script>
import Misc from '@/services/Misc';
import Vue from 'vue';
import Validation from './Validation.vue';

export default {
	name: 'FormSelect',
	components: {
		Validation,
	},
	props: {
		label: {
			type: String,
			required: false,
		},
		helper: {
			type: String,
			required: false,
		},
		value: {
			required: true,
		},
		disabled: {
			type: String,
			required: false,
			default: '',
		},
		change: {
			type: Function,
			required: false,
			default: () => null,
		},
		required: {
			type: Boolean,
			required: false,
			default: false,
		},
		validation: {
			type: Object,
			required: false,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			Misc,
			id: Misc.generageRandomString(),
		};
	},
	computed: {
		isValid() {
			if (this.validation.length > 0 && this.validation.$invalid) {
				return true;
			} else if (this.validation.length > 0 && !this.validation.$invalid) {
				return false;
			}

			return false;
		},
	},
};
</script>
